import Masonry from "@mui/lab/Masonry";
import { Box, Divider, Paper, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa6";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { fetchWithToken } from "../../authentication/AuthProvider";
import RefreshButton from "../../components/button/RefreshButton";
import PivotablePieChart from "../../components/chart/PivotablePieChart";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import { TableHeaderContainer } from "../../components/container/TableHeaderContainer";
import { TableHeaderToolsContainer } from "../../components/container/TableHeaderToolsContainer";
import { TableTitleContainer } from "../../components/container/TableTitleContainer";
import ExportAsXLSXButton from "../../components/export/ExportAsXLSXButton";
import DateSelector from "../../components/input/DateSelector";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import config from "../../config";
import { DPP } from "../../db_access/dpp";
import { ProductPassportVisitLog } from "../../db_access/product_passport_visit_log";
import routing from "../../routing";
import { dpp_format } from "../Products/DPP/ProductDPP_Format";

const DPP_History = () => {
  const { t } = useTranslation();
  const { selectedProducts } = useContextProvider();
  const [selectedProduct, setSelectedProduct] = useState();
  const [passportLogs, setPassportLogs] = useState([]);
  const [visitLogs, setVisitLogs] = useState([]);
  const [timedVisitLogs, setTimedVisitLogs] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [startDate, setStartDate] = useState(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState(dayjs());
  const navigate = useNavigate();
  const categories = [
    {
      label: "Continent",
      value: "continent_code",
    },
    {
      label: "Country",
      value: "country_name",
    },
    {
      label: "Region",
      value: "region",
    },
    {
      label: "City",
      value: "city",
    },
    {
      label: "Device Type",
      value: "device_type",
    },
    {
      label: "Device OS",
      value: "device_os",
    },
  ];
  const labelField = (fieldName) => {
    const sx = {
      fontFamily: "Poppins",
      color: "black",
      fontWeight: 500,
      fontSize: "18px",
    };
    const text = (dpp_format.find((d) => d.field === fieldName) || { label: fieldName }).label;
    return <Typography sx={sx}>{text}</Typography>;
  };
  const getListItemDefs = (fieldName) => {
    return (dpp_format.find((d) => d.field === fieldName) || { label: fieldName }).itemDef;
  };
  const labelListField = (itemDefs, fieldName) => {
    const sx = {
      fontFamily: "Poppins",
      textWrap: "wrap",
      color: "black",
      textAlign: "left",
    };
    const text = (itemDefs.find((d) => d.field === fieldName) || { label: fieldName }).label;
    return <Typography sx={sx}>{text}</Typography>;
  };
  const iconChecked = (visible) => {
    return (
      <Box sx={{ display: visible ? "block" : "none", color: "green" }}>
        <IoMdCheckmarkCircleOutline size={18} />
      </Box>
    );
  };
  const iconUnchecked = (visible) => {
    return (
      <Box sx={{ display: visible ? "block" : "none" }}>
        <MdOutlineRadioButtonUnchecked size={18} />
      </Box>
    );
  };
  const labelFieldValue = (visible, alignLeft, value) => {
    return (
      <Box sx={{ display: visible ? "flex" : "none", justifyContent: alignLeft ? "left" : "right" }}>
        <Typography sx={{ fontFamily: "Poppins", textWrap: "wrap", textAlign: alignLeft ? "left" : "right" }}>{value}</Typography>
      </Box>
    );
  };
  const cardSimple = (value, alignLeft = true) => {
    return (
      <Box sx={{ display: "flex", justifyContent: alignLeft ? "left" : "right" }}>
        {iconChecked(value === true)}
        {iconUnchecked(value === false)}
        {labelFieldValue(typeof value === "string", alignLeft, value)}
      </Box>
    );
  };
  const cardForList = (fieldName, values) => {
    const listItemDefs = getListItemDefs(fieldName);
    if (values.length < 1) {
      return (
        <Box sx={{}}>
          <Typography>{t("Empty")}</Typography>
        </Box>
      );
    }
    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {values.map((v, i) => (
          <Box key={i}>
            {i !== 0 && (
              <Box sx={{ paddingY: 1 }}>
                <Divider />
              </Box>
            )}
            {Object.entries(v).map(([key, value], index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 1,
                }}>
                {labelListField(listItemDefs, key)}
                {iconChecked(value === true)}
                {iconUnchecked(value === false)}
                {labelFieldValue(typeof value === "string", false, value)}
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    );
  };
  const getVisits = () => {
    if (selectedProduct) {
      ProductPassportVisitLog.get(selectedProduct["id"])
        .then((res) => res.json())
        .then((data) => setVisitLogs(data));
    }
  };
  useEffect(() => {
    if (selectedProducts.length < 1) {
      navigate(routing.digital_passport.dashboard);
    }
  }, [selectedProducts]);
  useEffect(() => console.log(selectedProducts), [selectedProducts]);
  useEffect(() => console.log(selectedProduct), [selectedProduct]);
  useEffect(() => console.log(passportLogs), [passportLogs]);
  useEffect(() => setSelectedProduct(selectedProducts.length > 0 ? selectedProducts[0] : undefined), [selectedProducts]);
  useEffect(() => {
    if (selectedProduct) {
      DPP.get_published(selectedProduct["id"])
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            const passport_id = data[0]["_id"];
            const url = `${config.apiUrl}/api/dpp/passports/${passport_id}/audit-logs`;
            fetchWithToken(url, { ...config.method.GET })
              .then((res) => res.json())
              .then((data) => {
                if (data["success"]) {
                  setPassportLogs(data["data"].filter((d) => d["differences"]));
                }
              });
          }
        });
    }
  }, [selectedProduct]);
  useEffect(() => getVisits(), [selectedProduct]);
  useEffect(() => {
    const filtered = visitLogs.filter((s) => {
      const ts = dayjs(s.timestamp);
      return ts.isAfter(startDate) && ts.isBefore(endDate);
    });
    setTimedVisitLogs(filtered);
  }, [visitLogs, startDate, endDate]);
  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">{t("Digital Product Passport History")}</Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">{t("Understanding DPP benefits and managing published passports")}</Typography>
          </Box>
        </Box>
      </PageTitleContainer>
      <Box>
        <Paper variant="Table Container">
          <TableHeaderContainer>
            <TableTitleContainer>
              <Typography variant="Table Title">{t("Digital Product Passports Statistic")}</Typography>
            </TableTitleContainer>
            <TableHeaderToolsContainer>
              <ExportAsXLSXButton data={visitLogs} label={t("Download Visits")} filename="visits.xlsx" />
              <RefreshButton />
            </TableHeaderToolsContainer>
          </TableHeaderContainer>
          <Box sx={{ padding: 2 }}>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Box sx={{ flex: 1 }}>
                <DateSelector label={t("Start Date")} value={startDate} onChange={(newValue) => setStartDate(newValue)} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <DateSelector label={t("End Date")} value={endDate} onChange={(newValue) => setEndDate(newValue)} />
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center" }}>
              {categories.map((c, i) => (
                <Box sx={{ width: 500, height: 500 }}>
                  <PivotablePieChart title={`${t("Visits by")} ${t(c.label)}`} usages={timedVisitLogs} groupBy={c.value} />
                </Box>
              ))}
            </Box>
          </Box>
        </Paper>
        <Box sx={{ paddingY: 1 }}></Box>
        <Paper variant="Table Container">
          <TableHeaderContainer>
            <TableTitleContainer>
              <Box>
                <Typography variant="Table Title">{t("Digital Product Passport Logs")}</Typography>
              </Box>
            </TableTitleContainer>
            <Box
              sx={{
                backgroundColor: "rgba(23, 163, 74, 0.2)",
                marginY: "auto",
                marginX: 1,
                paddingX: 1.5,
                paddingY: 0.5,
                borderRadius: 4,
                alignItems: "center",
              }}>
              <Typography
                sx={{
                  color: "#166534",
                  fontFamily: "Poppins",
                }}>
                {passportLogs.length} {t("Logs")}
              </Typography>
            </Box>
          </TableHeaderContainer>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: 1,
              paddingY: 1,
            }}>
            {passportLogs.map((log, i) => (
              <Box>
                <Box sx={{ display: i === 0 ? "none" : "block", paddingY: 2, marginRight: 1 }}>
                  <Divider />
                </Box>
                <Masonry
                  columns={{ md: 1, lg: 2, xl: 3 }}
                  key={i}
                  sx={{
                    border: 1,
                    borderColor: "lightgray",
                    borderRadius: 2,
                    padding: 0,
                  }}>
                  {Object.entries(log["differences"]).map(([key, value], index) => (
                    <Box
                      key={index}
                      sx={{
                        borderRadius: 2,
                        padding: 1,
                        background: "linear-gradient(to bottom, rgba(23, 163, 74, 0.1), #ffffff)",
                      }}>
                      {labelField(key)}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          paddingY: 1,
                          paddingX: 2,
                        }}>
                        <Box sx={{ flex: 1 }}>{Array.isArray(value["from"]) ? <Box>{cardForList(key, value["from"])}</Box> : <Box>{cardSimple(value["from"], false)}</Box>}</Box>
                        <Box sx={{ marginY: "auto" }}>
                          <FaArrowRight size={18} />
                        </Box>

                        <Box sx={{ flex: 1 }}>{Array.isArray(value["to"]) ? <Box>{cardForList(key, value["to"])}</Box> : <Box>{cardSimple(value["to"])}</Box>}</Box>
                      </Box>
                    </Box>
                  ))}
                </Masonry>
              </Box>
            ))}
          </Box>
        </Paper>
      </Box>
    </MainContainer>
  );
};
export default DPP_History;
